import React from 'react';
import { Seo } from '../components/Seo';
import { PageHeader } from '../components/PageHeader';
import { GalleryGrid } from '../components/GalleryGrid';
import { CtaBand } from '../components/CtaBand';
import { useLanguage } from '../contexts/LanguageContext';
import { copy } from '../data/copy';
export function Gallery() {
  const {
    t
  } = useLanguage();
  const page = copy.pages.gallery;
  return <>
      <Seo title={t(copy.seo.gallery.title)} description={t(copy.seo.gallery.description)} data-id="element-391" data-mp="2meqpnqimgdlc" />
      <PageHeader eyebrow={t(page.eyebrow)} title={t(page.title)} description={t(page.description)} data-id="element-392" data-mp="2hmyzvi7aibw9" />

      <section className="bg-white py-14 sm:py-16" data-id="element-393" data-mp="2cml3wyiyqsel">
        <div className="mx-auto max-w-7xl px-6" data-id="element-394" data-mp="27qm6ymjkk22k">
          <GalleryGrid data-id="element-395" data-mp="27nq88vzwd9d2" />
        </div>
      </section>

      <CtaBand title={page.ctaTitle} description={page.ctaDescription} data-id="element-396" data-mp="23mxze3uxt6hb" />
    </>;
}